import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Shipment, ShipmentStatusCommand } from '../../models/order/shipment';
import { ApiResponse } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class ShipmentProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/shipment-order';

  public getShipments(): Observable<ApiResponse<Shipment[]>> {
    return this.httpClient.get<ApiResponse<Shipment[]>>(`${this.baseUrl}/all`);
  }

  public getShipment(id: string): Observable<ApiResponse<Shipment>> {
    return this.httpClient.get<ApiResponse<Shipment>>(`${this.baseUrl}/${id}`);
  }

  public updateShipmentStatus(command: ShipmentStatusCommand, id: string): Observable<ApiResponse<Shipment>> {
    return this.httpClient.patch<ApiResponse<Shipment>>(`${this.baseUrl}/${id}/status`, command);
  }

  public getShipmentByInvoiceReference(invoiceReference: string): Observable<ApiResponse<Shipment>> {
    return this.httpClient.get<ApiResponse<Shipment>>(`${this.baseUrl}/invoice-reference/${invoiceReference}`);
  }

  public shipmentReport(id: string): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/report/${id}`, { responseType: 'blob' });
  }
}
